<div class="container">
  <div class="row">
    <div style="width:100%;" class="ps-0 pe-0">
      <div class="app_card-body">
        <h1 class="header_text">{{ 'APP_STATUS_HEADER' | globalTranslate }}</h1>
        <hr>
          @if (appDetails?.length) {
            <section>
              <p>
                <span [innerHTML]="'APP_STATUS_SUBTITLE' | globalTranslate"></span>
                <span><b [innerHTML]="'APP_STATUS_SUBTITLE_01' | globalTranslate"></b></span>
                <span [innerHTML]="'APP_STATUS_SUBTITLE_02' | globalTranslate"></span>
                <span><b [innerHTML]="'APP_STATUS_SUBTITLE_03' | globalTranslate"></b></span>
                <span [innerHTML]="'APP_STATUS_SUBTITLE_04' | globalTranslate"></span>
                <span><b [innerHTML]="'APP_STATUS_SUBTITLE_05' | globalTranslate"></b></span>
                <span [innerHTML]="'APP_STATUS_SUBTITLE_06' | globalTranslate"></span>
              </p>
              <div class="d-none d-lg-block">
                <table class="table w-100">
                  <thead>
                    <tr>
                      <th scope="col" style="width:25%" class="table-header">{{'APP_TYPE' | globalTranslate}}</th>
                      <th scope="col" style="width:25%" class="table-header">{{'SUBMIT_DATE' | globalTranslate}}</th>
                      <th scope="col" style="width:25%" [ngClass]="{'table_align': translatedLang !== 'en'}" class="sub_header">{{'Track_status' | globalTranslate}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (record of paginatedData; track record; let i = $index) {
                      <tr [ngClass]="{'odd-row' : i % 2 === 0, 'even-row': i % 2 !== 0 }">
                        <td style="width:25%;padding-left:4%">{{ getAppTypeLabel(record?.appType) | globalTranslate }}: {{record?.wpAppnumber}}</td>
                        <td style="width:25%;padding-left:4%">{{record?.submissionDate}}</td>
                        <td tabindex="0" style="padding-left:21%" class="track_app"
                          role="button"
                          [attr.aria-expanded]="expandedIndex === i"
                          [attr.aria-controls]="'status-details-' + i"
                          [attr.aria-label]="(expandedIndex === i ? ('COLLAPSE_TRACK_SUBMISSION' | globalTranslate) : ('EXPAND_TRACK_SUBMISSION' | globalTranslate)) + ' ' + (getAppTypeLabel(record?.appType) | globalTranslate) + ' ' + ('APP_WORD' | globalTranslate) + ' ' + record?.wpAppnumber"
                          (click)="toggleExpand(i, record?.wpAppnumber)"
                          (keydown.enter)="toggleExpand(i, record?.wpAppnumber)"
                          (keydown.space)="$event.preventDefault(); toggleExpand(i, record?.wpAppnumber)">
                          <span [ngStyle]="{'white-space': ((translatedLang === 'en' || translatedLang === 'sp') && !globalLanguage) ? 'nowrap' : 'normal', 'font-size': globalLanguage === 'tl' ? '14px' : 'inherit'}">{{'TRACK_SUBMISSION' | globalTranslate}}</span>
                          <mat-icon [ngClass]="{'toggle' : expandedIndex === i }" [attr.aria-hidden]="true">keyboard_arrow_down</mat-icon>
                        </td>
                      </tr>
                      @if (expandedIndex === i) {
                        <tr class="status-details"
                          [ngClass]="{'odd-row' : i % 2 === 0, 'even-row': i % 2 !== 0 }"
                          [attr.id]="'status-details-' + i"
                          role="region"
                          [attr.aria-label]="('APP_STATUS_DETAILS' | globalTranslate) + ' ' + (getAppTypeLabel(record?.appType) | globalTranslate) + ' ' + ('APP_WORD' | globalTranslate) + ' ' + record?.wpAppnumber">
                          <td colspan="6">
                            @if (!submissionStatusAllAppsSwitch) {
                              @if (loadingStatusMap[record?.wpAppnumber]) {
                                <span>
                                  <div class="spinner">
                                    <img alt="spinningWheel" src="assets/images/loading.svg" />
                                  </div>
                                </span>
                              } @else {
                                @if (!record?.appTrackstatus) {
                                  <p class="text_size mobile_align">{{'NO_STATUS_TEXT' | globalTranslate }}</p>
                                }
                              }
                            }
                            @if (!submissionStatusAllAppsSwitch) {
                              @if (!loadingStatusMap[record?.wpAppnumber] && record?.appTrackstatus) {
                                <span>
                                  <div class="status-container" [ngClass]="{'table_sp': translatedLang !== 'en', 'tl-font-size': globalLanguage === 'tl'}" aria-hidden="true">
                                    @for (status of getDisplayStatus(record?.appTrackstatus); track status) {
                                      <span class="status-box"
                                        [ngClass]="getStatusClass(status, record.appTrackstatus)">
                                        @if (status === 'INFORMATION NEEDED') {
                                          <mat-icon class="info_icon" aria-hidden="true">info_outline</mat-icon>
                                        }
                                        <span>{{status | globalTranslate}}</span>
                                      </span>
                                    }
                                  </div>
                                </span>
                              }
                            }
                            @if (submissionStatusAllAppsSwitch) {
                              <div class="status-container" [ngClass]="{'tl-font-size': globalLanguage === 'tl'}" class="text_size" aria-hidden="true">
                                @for (status of getDisplayStatus(record?.appTrackstatus); track status) {
                                  <span class="status-box"
                                    [ngClass]="getStatusClass(status, record.appTrackstatus)">
                                    @if (status === 'INFORMATION NEEDED') {
                                      <mat-icon class="info_icon" aria-hidden="true">info_outline</mat-icon>
                                    }
                                    <span>{{status | globalTranslate}}</span>
                                  </span>
                                }
                              </div>
                            }
                            @if (record?.appTrackstatus === 'SUBMITTED' && this.appSubmittedBy === 'MP') {
                              <p class="text_size">
                                <span>{{getAppTypeLabel(record?.appType) | globalTranslate}}: {{record?.wpAppnumber}} {{'WAS_SUBMITTED_ON' | globalTranslate}} {{record?.submissionDateOnly}}</span>
                                <span>{{"GO_TO" | globalTranslate}} <a tabindex="0" (click)="goToSubmissions()" class="add-primary-color">{{'MY_SUBMISSONS' | globalTranslate }}</a></span>
                                <span>{{'SUBMITTED_STATUS_TEXT_01' | globalTranslate}}</span>
                              </p>
                            }
                            @if (record?.appTrackstatus === 'SUBMITTED' && this.appSubmittedBy === 'PP') {
                              <p class="text_size">
                                <span>{{getAppTypeLabel(record?.appType) | globalTranslate}}: {{record?.wpAppnumber}} {{'WAS_SUBMITTED_ON' | globalTranslate}} {{record?.submissionDateOnly}}</span>
                                <span>{{"GO_TO" | globalTranslate}} <b>{{'SEARCH_MY_SUBMISSIONS' | globalTranslate}}</b></span>
                                <span>{{'SUBMITTED_STATUS_TEXT_01' | globalTranslate}}</span>
                              </p>
                            }
                            @if (record?.appTrackstatus === 'REVIEW IN PROGRESS') {
                              <p class="text_size">
                                <span>{{'INREVIEW_STATUS_TEXT_01' | globalTranslate}}</span>
                                @if (translatedLang === 'en') {
                                  <span>{{getProcessedAppTypeLabel(record.appType)|globalTranslate}}.</span>
                                }
                                @if (translatedLang === 'sp') {
                                  <span>{{getProcessedAppTypeLabelSP(record.appType)|globalTranslate}}.</span>
                                }
                                <span>{{ 'INREVIEW_STATUS_TEXT_02' | globalTranslate }}</span>
                              </p>
                            }
                            @if (record?.appTrackstatus === 'INFORMATION NEEDED') {
                              <p class="text_size">
                                <span>{{'INFORMATION_NEEDED_STATUS_TEXT' | globalTranslate }}</span>
                                @if (translatedLang === 'en') {
                                  <span>{{getProcessedAppTypeLabel(record.appType)|globalTranslate}}.</span>
                                }
                                @if (translatedLang === 'sp') {
                                  <span>{{getProcessedAppTypeLabelSP(record.appType)|globalTranslate}}.</span>
                                }
                                <span>{{"GO_TO" | globalTranslate}} <a tabindex="0" (click)="goToDocuments()" class="add-primary-color">{{'MY_DOCUMENTS' | globalTranslate }}</a></span>
                                <span>{{"INFORMATION_NEEDED_STATUS_TEXT_02" | globalTranslate}}</span>
                              </p>
                            }
                            @if (record?.appTrackstatus === 'PROCESSED') {
                              <p class="text_size">
                                <span>{{'YOUR' | globalTranslate}}</span>
                                @if (translatedLang === 'en') {
                                  <span>{{getProcessedAppTypeLabel(record.appType)|globalTranslate}}</span>
                                }
                                @if (translatedLang === 'sp') {
                                  <span>{{getProcessedAppTypeLabelSP(record.appType)|globalTranslate}}</span>
                                }
                                <span>{{'PROCESSED_STATUS_TEXT' | globalTranslate}}</span>
                                <span>{{"GO_TO" | globalTranslate}} <a tabindex="0" (click)="goToDashboard()" class="add-primary-color">{{'COVERAGE_DASHBOARD' | globalTranslate }}</a></span>
                                <span>{{'PROCESSED_STATUS_TEXT_01' | globalTranslate}}&nbsp;<a tabindex="0" (click)="goToMyLetters()" class="add-primary-color">{{'MY_LETTERS' | globalTranslate }}.</a></span>
                              </p>
                            }
                            @if (record?.appTrackstatus) {
                              <div>
                                <span>{{'APP_STATUS_TEXT_01' | globalTranslate}}</span><a tabindex="0" (click)="learnMore()" class="learn_more pe-2">{{'here' | globalTranslate }}.</a>
                              </div>
                            }
                          </td>
                        </tr>
                      }
                    }
                  </tbody>
                </table>
                @if (this.appDetails?.length > 5) {
                  <div class="custom-pagination">
                    <button (click)="changePage(1)" [disabled]="currentPage === 1" [ngClass]="{'next-page': currentPage !== 1}" [attr.aria-label]="'Go to first page'"><span aria-hidden="true"><<</span></button>
                    <button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1" [ngClass]="{'next-page': currentPage !== 1}" [attr.aria-label]="'Go to previous page'"><span aria-hidden="true"><</span></button>
                    @for (page of pages; track page) {
                      <button (click)="changePage(page)" [ngClass]="{'active-page': page === currentPage}" [attr.aria-label]="page === currentPage ? 'Page ' + page + ', current page' : 'Go to page ' + page" [attr.aria-current]="page === currentPage ? 'page' : null">
                        <span class="page_num" aria-hidden="true">{{page}}</span>
                      </button>
                    }
                    <button (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages" [ngClass]="{'next-page': currentPage !== totalPages}" [attr.aria-label]="'Go to next page'"><span aria-hidden="true">></span>
                  </button>
                  <button (click)="changePage(totalPages)" [disabled]="currentPage === totalPages" [ngClass]="{'next-page': currentPage !== totalPages}" [attr.aria-label]="'Go to last page'"><span aria-hidden="true">>></span></button>
                </div>
              }
            </div>
            <div class="nh-table-mobile d-lg-none">
              @for (record of appDetails; track record; let i = $index) {
                <div>
                  <div class="table-row mb-3 pb-3 item active">
                    <div class="mobile-table-header">{{'APP_TYPE' | globalTranslate}}</div>
                    <hr>
                      <div  class="mobile-table-data">{{getAppTypeLabel(record?.appType) | globalTranslate}}: {{record?.wpAppnumber}}</div>
                      <br>
                        <div class="mobile-table-header">{{'SUBMIT_DATE' | globalTranslate}}</div>
                        <hr>
                          <div class="mobile-table-data">{{record?.submissionDate}}</div>
                          <br>
                            <div class="mobile-table-header">{{'Track_status' | globalTranslate}}</div>
                            <hr>
                              <div class="mobile-table-data">
                                <div class="track_app"
                                  role="button"
                                  tabindex="0"
                                  [attr.aria-expanded]="expandedIndex === i"
                                  [attr.aria-controls]="'mobile-status-details-' + i"
                                  [attr.aria-label]="(expandedIndex === i ? ('COLLAPSE_TRACK_SUBMISSION' | globalTranslate) : ('EXPAND_TRACK_SUBMISSION' | globalTranslate)) + ' ' + (getAppTypeLabel(record?.appType) | globalTranslate) + ' ' + ('APP_WORD' | globalTranslate) + ' ' + record?.wpAppnumber"
                                  (click)="toggleExpand(i, record?.wpAppnumber)"
                                  (keydown.enter)="toggleExpand(i, record?.wpAppnumber)"
                                  (keydown.space)="$event.preventDefault(); toggleExpand(i, record?.wpAppnumber)">
                                  <span>{{'TRACK_SUBMISSION' | globalTranslate}}</span>
                                  <mat-icon [ngClass]="{'toggle' : expandedIndex === i }" [attr.aria-hidden]="true">keyboard_arrow_down</mat-icon>
                                </div>
                                @if (expandedIndex === i) {
                                  <div class="status-details"
                                    [attr.id]="'mobile-status-details-' + i"
                                    role="region"
                                    [attr.aria-label]="('APP_STATUS_DETAILS' | globalTranslate) + ' ' + (getAppTypeLabel(record?.appType) | globalTranslate) + ' ' + ('APP_WORD' | globalTranslate) + ' ' + record?.wpAppnumber">
                                    <div colspan="3">
                                      @if (!submissionStatusAllAppsSwitch) {
                                        @if (loadingStatusMap[record?.wpAppnumber]) {
                                          <span>
                                            <div class="spinner">
                                              <img alt="spinningWheel" src="assets/images/loading.svg" />
                                            </div>
                                          </span>
                                        } @else {
                                          @if (!record?.appTrackstatus) {
                                            <p class="text_size web_align">{{'NO_STATUS_TEXT' | globalTranslate }}</p>
                                          }
                                        }
                                      }
                                      @if (!submissionStatusAllAppsSwitch) {
                                        @if (!loadingStatusMap[record?.wpAppnumber] && record?.appTrackstatus) {
                                          <span>
                                            <div class="status-container" [ngClass]="{'information-needed': record.appTrackstatus === 'INFORMATION NEEDED'}" aria-hidden="true">
                                              @for (status of getDisplayStatus(record.appTrackstatus); track status) {
                                                <span class="status-box"
                                                  [ngClass]="getStatusClass(status, record.appTrackstatus)">
                                                  <span [ngClass]="{'status_text': status === 'INFORMATION NEEDED'}">
                                                    @if (status === 'INFORMATION NEEDED') {
                                                      <mat-icon class="info_icon" aria-hidden="true">info_outline</mat-icon>
                                                    }
                                                    <span>{{status | globalTranslate}}</span>
                                                  </span>
                                                </span>
                                              }
                                            </div>
                                          </span>
                                        }
                                      }
                                      @if (submissionStatusAllAppsSwitch) {
                                        <div>
                                          <div class="status-container" [ngClass]="{'information-needed': record.appTrackstatus === 'INFORMATION NEEDED'}" aria-hidden="true">
                                            @for (status of getDisplayStatus(record.appTrackstatus); track status) {
                                              <span class="status-box"
                                                [ngClass]="getStatusClass(status, record.appTrackstatus)">
                                                <span [ngClass]="{'status_text': status === 'INFORMATION NEEDED'}">
                                                  @if (status === 'INFORMATION NEEDED') {
                                                    <mat-icon class="info_icon" aria-hidden="true">info_outline</mat-icon>
                                                  }
                                                  <span>{{status | globalTranslate}}</span>
                                                </span>
                                              </span>
                                            }
                                          </div>
                                        </div>
                                      }
                                      @if (record?.appTrackstatus === 'SUBMITTED' && this.appSubmittedBy === 'MP') {
                                        <p class="text_size">
                                          <span>{{getAppTypeLabel(record?.appType) | globalTranslate}}: {{record?.wpAppnumber}} {{'WAS_SUBMITTED_ON' | globalTranslate}} {{record?.submissionDateOnly}}</span>
                                          <span>{{"GO_TO" | globalTranslate}} <a tabindex="0" (click)="goToSubmissions()" class="add-primary-color">{{'MY_SUBMISSONS' | globalTranslate }}</a></span>
                                          <span>{{'SUBMITTED_STATUS_TEXT_01' | globalTranslate}}</span>
                                        </p>
                                      }
                                      @if (record?.appTrackstatus === 'SUBMITTED' && this.appSubmittedBy === 'PP') {
                                        <p class="text_size">
                                          <span>{{getAppTypeLabel(record?.appType) | globalTranslate}}: {{record?.wpAppnumber}} {{'WAS_SUBMITTED_ON' | globalTranslate}} {{record?.submissionDateOnly}}</span>
                                          <span>{{"GO_TO" | globalTranslate}} <b>{{'SEARCH_MY_SUBMISSIONS' | globalTranslate}}</b></span>
                                          <span>{{'SUBMITTED_STATUS_TEXT_01' | globalTranslate}}</span>
                                        </p>
                                      }
                                      @if (record?.appTrackstatus === 'REVIEW IN PROGRESS') {
                                        <p class="text_size">
                                          <span>{{'INREVIEW_STATUS_TEXT_01' | globalTranslate}}</span>
                                          @if (translatedLang === 'en') {
                                            <span>{{getProcessedAppTypeLabel(record.appType)|globalTranslate}}.</span>
                                          }
                                          @if (translatedLang === 'sp') {
                                            <span>{{getProcessedAppTypeLabelSP(record.appType)|globalTranslate}}.</span>
                                          }
                                          <span>{{ 'INREVIEW_STATUS_TEXT_02' | globalTranslate }}</span>
                                        </p>
                                      }
                                      @if (record?.appTrackstatus === 'INFORMATION NEEDED') {
                                        <p class="text_size">
                                          <span>{{'INFORMATION_NEEDED_STATUS_TEXT' | globalTranslate }}</span>
                                          @if (translatedLang === 'en') {
                                            <span>{{getProcessedAppTypeLabel(record.appType)|globalTranslate}}.</span>
                                          }
                                          @if (translatedLang === 'sp') {
                                            <span>{{getProcessedAppTypeLabelSP(record.appType)|globalTranslate}}.</span>
                                          }
                                          <span>{{"GO_TO" | globalTranslate}} <a tabindex="0" (click)="goToDocuments()" class="add-primary-color">{{'MY_DOCUMENTS' | globalTranslate }}</a></span>
                                          <span>{{"INFORMATION_NEEDED_STATUS_TEXT_02" | globalTranslate}}</span>
                                        </p>
                                      }
                                      @if (record?.appTrackstatus === 'PROCESSED') {
                                        <p class="text_size">
                                          <span>{{'YOUR' | globalTranslate}}</span>
                                          @if (translatedLang === 'en') {
                                            <span>{{getProcessedAppTypeLabel(record.appType)|globalTranslate}}</span>
                                          }
                                          @if (translatedLang === 'sp') {
                                            <span>{{getProcessedAppTypeLabelSP(record.appType)|globalTranslate}}</span>
                                          }
                                          <span>{{'PROCESSED_STATUS_TEXT' | globalTranslate}}</span>
                                          <span>{{"GO_TO" | globalTranslate}} <a tabindex="0" (click)="goToDashboard()" class="add-primary-color">{{'COVERAGE_DASHBOARD' | globalTranslate }}</a></span>
                                          <span>{{'PROCESSED_STATUS_TEXT_01' | globalTranslate}}&nbsp;<a tabindex="0" (click)="goToMyLetters()" class="add-primary-color">{{'MY_LETTERS' | globalTranslate }}.</a></span>
                                        </p>
                                      }
                                      @if (record?.appTrackstatus) {
                                        <div>
                                          <span>{{'APP_STATUS_TEXT_01' | globalTranslate}}</span><a tabindex="0" (click)="learnMore()" class="learn_more pe-2">{{'here' | globalTranslate }}.</a>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </section>
                  }
                  @if (!appDetails.length) {
                    <p>{{'SUBMISSION_NODATA' | globalTranslate}}<a tabindex="0" (click)="goToDashboard()" class="add-primary-color">{{'COVERAGE_DASHBOARD' | globalTranslate }}</a>&nbsp;{{'SUBMISSION_NODATA_01' | globalTranslate}}</p>
                  }
                </div>
              </div>
            </div>
          </div>